/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function Icon3dView({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="3d-view"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M8 3.5L5.5 3.5C4.395 3.5 3.5 4.395 3.5 5.5L3.5 8" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M16 3.5L18.5 3.5C19.605 3.5 20.5 4.395 20.5 5.5L20.5 8" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M8 20.5L5.5 20.5C4.395 20.5 3.5 19.605 3.5 18.5L3.5 16" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M16 20.5L18.5 20.5C19.605 20.5 20.5 19.605 20.5 18.5L20.5 16" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12.564 17.174C12.215 17.376 11.785 17.376 11.436 17.174L7.801 15.076C7.452 14.874 7.237 14.502 7.237 14.099L7.237 9.901C7.237 9.498 7.452 9.126 7.801 8.924L11.436 6.826C11.785 6.624 12.215 6.624 12.564 6.826L16.199 8.924C16.548 9.126 16.763 9.498 16.763 9.901L16.763 14.099C16.763 14.502 16.548 14.874 16.199 15.076L12.564 17.174Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12 12L16.45 9.431" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12 12L12 17.083" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12 12L7.55 9.431" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
